export default __webpack_public_path__ + "static/media/official_logo_minified.da3c941f.png";